export const ContentProp = {
  name: "Content",
  nameI18n: "builder_ui.block_props_category.content",
} as const;

export const FontProp = {
  name: "Font",
  nameI18n: "builder_ui.block_props_category.font",
} as const;

export const DesignProp = {
  name: "Design",
  nameI18n: "builder_ui.block_props_category.design",
} as const;

export const BorderProp = {
  name: "Border",
  nameI18n: "builder_ui.block_props_category.border",
} as const;

export const PaddingsProp = {
  name: "Padding",
  nameI18n: "builder_ui.block_props_category.padding",
} as const;

export const ColorsProp = {
  name: "Colors",
  nameI18n: "builder_ui.block_props_category.colors",
} as const;

export const LayoutProp = {
  name: "Layout",
  nameI18n: "builder_ui.block_props_category.layout",
} as const;

export const BackgroundProp = {
  name: "Background",
  nameI18n: "builder_ui.block_props_category.background",
} as const;

export const MarginsProp = {
  name: "Margins",
  nameI18n: "builder_ui.block_props_category.margins",
} as const;

export const CornersProp = {
  name: "Corners",
  nameI18n: "builder_ui.block_props_category.corners",
} as const;

export const SizingProp = {
  name: "Sizing",
  nameI18n: "builder_ui.block_props_category.sizing",
} as const;

export const GeneralProp = {
  name: "General",
  nameI18n: "builder_ui.block_props_category.general",
} as const;

export const OtherProp = {
  name: "Other",
  nameI18n: "builder_ui.block_props_category.other",
} as const;

export type PropCategoryName =
  | (typeof ContentProp)["name"]
  | (typeof DesignProp)["name"]
  | (typeof FontProp)["name"]
  | (typeof BorderProp)["name"]
  | (typeof PaddingsProp)["name"]
  | (typeof ColorsProp)["name"]
  | (typeof GeneralProp)["name"]
  | (typeof LayoutProp)["name"]
  | (typeof BackgroundProp)["name"]
  | (typeof MarginsProp)["name"]
  | (typeof CornersProp)["name"]
  | (typeof SizingProp)["name"];
